import React, { useEffect, useState } from 'react';
export const useGeolocation = () => {
      const [coordinates, setCoordinates] = useState(null);

      useEffect(() => {
            if ("geolocation" in navigator) {
                  navigator.geolocation.getCurrentPosition(
                        position => {
                              setCoordinates({
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                              });
                        },
                        error => console.error(error)
                  );
            }
      }, []);

      return { coordinates };
};